import { Separator } from 'telia-front-react';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import RoamingStore from '../../../stores/RoamingStore';
import { INTERNET_SERVICE_GROUP_ID } from '../../RoamingInterfaces';
import GroupServiceTable from './GroupServiceTable';
import ServiceGroupComments from './ServiceGroupComments';

interface InternetServiceGroupProps {
  roamingStore?: RoamingStore;
}

@observer
class InternetServiceGroup extends React.Component<InternetServiceGroupProps> {
  public render() {
    const { roamingStore } = this.props;

    if (!roamingStore.isMobileInternetCountry()) {
      return null;
    }
    return (
      <>
        <GroupServiceTable serviceGroupId={INTERNET_SERVICE_GROUP_ID} />
        <Separator spacing="small" color="invisible" />
        <ServiceGroupComments serviceGroupId={INTERNET_SERVICE_GROUP_ID} />
      </>
    );
  }
}

export default inject('roamingStore')(InternetServiceGroup);
